import gsap from 'gsap'
import { mapGetters } from 'vuex'
import { focusables } from '@/mixins/focusables'
import { focusOrder } from '@/mixins/focusOrder'

export const videos = {
    computed: {
        video() {
            return require(`@/assets/videos/${this.media}.mp4`)
        },
        transcript() {
            try {
                return require(`@/assets/videos/${this.media}.vtt`)
            }
            catch {
                return null
            }
        },
    },
}

export const browser = {
    computed: {
        offset() {
            const { width } = this.browserSize
            return this.getCurrentOffset(width, this.currentSlide)
        },
        ...mapGetters({
            browserSize: 'browser/size',
        })
    },
    watch: {
        browserSize({ width }) {
            if (!this.$refs.slides) return;

            gsap.set( 
                this.$refs.slides, 
                { x: this.getCurrentOffset(width, this.currentSlide) }
            )
        },
    },
    methods: {
        getCurrentOffset( width, current = 0 ) {
            return !current ? 0 : current * -width
        },
    },
}

export const setup = {
    computed: {
        dynamicStoriesSlug() {
            const pageSlugs = [
                'purple', 'impact', 'success', 'belong', 'self',
            ]
            return pageSlugs[this.currentSlide]
        },
        dynamicStories() {
            const { stories } = this.stories[this.currentSlide]
            return stories || null
        },
    },
    mixins: [
        focusables,
        focusOrder,
    ],
    methods: {
        disableFocusables( slide ) {
            if ( this.isMobile() ) {
                const { slides } = this.getSlideSelectors()
                return this.focusables()
                    // .rm( stories )
                    .add( slides )
            }
            setTimeout(() => {
                const { slides } = this.getSlideSelectors()
                const slidesCurrent = document.querySelector(`.slide--${(slide + 1)}`)
                
                this.focusables()
                    // .rm( stories )
                    .rm( slides )
                    .add( slidesCurrent )
            }, 200)
        },
        disableStories(locked = false) {
            if ( locked || document.querySelector('.stories-view') ) {
                this.$root.$emit('hide-stories', true)
            }
        },
        getSlideSelectors() {
            const topElems = [
                document.querySelector('.logo'), 
                document.querySelector('.main-menu__trigger')
            ]
            if (document.querySelector('.wrapper--corner-buttons > *')) {
                topElems.push(document.querySelector('.wrapper--corner-buttons > *'))
            }
            return {
                elems: topElems,
                // stories: document.querySelector('.stories'),
                slides: this.$refs.slides
            }
        },
    },
}